export default __webpack_public_path__ + "static/media/(2).f562dc8f.jpeg";